import React, { Component } from 'react';
import Widget02 from '../../Widgets/Widget02';
import {
    Row,
    Col,
    Badge,
} from "reactstrap";

class VerificationStatus extends Component {

    constructor(props){
        super(props)
        this.state = {

        }
    }

    render() {
        let loan_status_check = window.localStorage.getItem('loan_status_check');
        return (
            <div>                
                <Row>            
                    <Col xs="12" md="4" sm="6" >
                        <Widget02 header={loan_status_check == 'hide' ? "******"+this.props.phone.substring(this.props.phone.length - 4) :  this.props.phone} mainText={this.props.phoneVerified?'Verified':'Not verified'} icon="fa fa-mobile" color={this.props.phoneVerified?'success':'danger'} footer={this.props.showPhoneVerify} link={this.props.phoneToggle}/>
                    </Col>
                    <Col xs="12" md="4" sm="6" >
                        <Widget02 header={loan_status_check == 'hide' ? this.props.email.substring(0,6)+"****.com" : this.props.email} mainText={this.props.emailVerified?'Verified':'Not verified'} icon="fa fa-envelope-o" color={this.props.emailVerified?'success':'danger'} footer={this.props.showEmailVerify} link={this.props.emailToggle}/>
                    </Col>
                    <Col xs="12" md="4" sm="6" >
                        <Widget02 header={loan_status_check == 'hide' ? this.props.ofcEmail.substring(0,6)+"****.com" : this.props.ofcEmail} mainText={this.props.ofcEmailVerified?'Verified':'Not verified'} icon="fa fa-envelope-o" color={this.props.ofcEmailVerified?'success':'danger'} footer={this.props.showOfcEmailVerify} link={this.props.ofcEmailToggle}/>
                    </Col>
                    <Col xs="12" md="4" sm="6" >
                        <Widget02 header="Bureau Status" mainText={this.props.cibilStatus?'Fetched':'Not fetched'} icon="fa fa-bank" color={this.props.cibilStatus?'success':'danger'} footer={this.props.showCibilVerify} link={this.props.CibilToggle} />
                    </Col>
                    <Col xs="12" md="4" sm="6" >
                        <Widget02 header="Banking" mainText={this.props.perfiosStatus?'Done':'Not done'} icon="fa fa-drivers-license-o" color={this.props.perfiosStatus?'success':'danger'} footer={this.props.showPerfiosVerify} link={this.props.togglePerfios}/>
                    </Col>
                    <Col xs="12" md="4" sm="6" >
                        <Widget02 header="Document Uploaded" mainText={this.props.docsUploaded?'Uploaded':'Not Uploaded'} icon="fa fa-file-text-o" color={this.props.docsUploaded?'success':'danger'} footer={this.props.showDocUploadLink} link={this.props.toggleDocLink}/>
                    </Col>
                </Row>                
            </div>
        );
    }
}

export default VerificationStatus;  




// WEBPACK FOOTER //
// ./src/views/Pages/LoanApplicationDetails/VerificationStatus.js